module.exports = __webpack_public_path__ + "img/3.452d29f2.jpg";